import { CUSTOMER_NAME } from '../constants';

export const loginRedirect = ({ loginUrl }) => {
	const loginLocation = loginUrl
		.replace(/\{customer\}/g, CUSTOMER_NAME)
		.replace(/\{return_to\}/g, window.location);
	window.location = loginLocation;
};
